import React, { useState, useEffect } from "react";
import Select from "react-select";
import _ from "lodash";
import { useHistory, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import { pages, titles } from "../../Constants/selections";

import "./index.css";
const TokenOffer = require("../../assets/media/community_tabs/token-offers.png");
const DiscountOffer = require("../../assets/media/community_tabs/discount.png");
const EarnTokens = require("../../assets/media/community_tabs/chip.png");
const Community = require("../../assets/media/community_tabs/connection.png");
const MyProfile = require("../../assets/media/community_tabs/security.png");
const Forum = require("../../assets/media/community_tabs/forum.png");
const Polls = require("../../assets/media/community_tabs/opinion.png");
const Shop = require("../../assets/media/community_tabs/shop.png");
const Ecopay = require("../../assets/media/community_tabs/pay.png");
const Friends = require("../../assets/media/community_tabs/eco-friendly.png");
const Concierge = require("../../assets/media/community_tabs/concierge.png");
const Wallet = require("../../assets/media/community_tabs/wallet.jpg");
const Timeline = require("../../assets/media/community_tabs/timeline.png");
const Support = require("../../assets/media/community_tabs/support.png");
const Ecosystem = require("../../assets/media/community_tabs/ecosystem.png");
const TokenPay = require("../../assets/media/community_tabs/tokenPay.png");
const Events = require("../../assets/media/community_tabs/event.png");
const Reviews = require("../../assets/media/community_tabs/review.png");
const Saving = require("../../assets/media/community_tabs/saving.png");

const images = {
  explore: Ecosystem,
  support: Support,
  tokenPay: TokenPay,
  feeds: Forum,
  polls: Polls,
  friends: Friends,
  community: Community,
  events: Events,
  reviews: Reviews,
  wallet: Wallet,
  ecopay: Ecopay,
  tokenOffers: TokenOffer,
  discountOffers: DiscountOffer,
  earnTokens: EarnTokens,
  shop: Shop,
  saving: Saving,
  myId: MyProfile,
  timeline: Timeline,
};
const groups = Object.keys(images).map((key) => {
  return {
    toolName: titles[key],
    asset: <img src={images[key]} className="community-tab-icon"></img>,
    pageName: pages[key].id,
  };
});
const PlatformLinks = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [role, setRole] = useState(0);
  const [username, setUserName] = useState("");
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [loading, setLoading] = useState(true);
  const [demoUser, setDemoUser] = useState(null);
  useEffect(() => {
    const umbrellaBrand = Number(localStorage.getItem("umbrella"));
    if (!location.state) {
      history.push("/");
    } else {
      const { role, username } = location.state;
      setRole(role);
      setUserName(username);
      Firebase.getAllBrands((res) => {
        let total_brands = res
          .map((item, index) => {
            let new_item = item;
            new_item.id = index;
            return new_item;
          })
          .filter((item) => item && !item.deactive);
        let brands = total_brands.filter(
          (item) =>
            !(
              item.salesStage === "Test Roll Out" ||
              item.salesStage === "Full Roll Out"
            )
        );
        if (role === 10) {
          brands = brands.filter((obj) => obj.parent === umbrellaBrand);
        }
        //set default demo as Ecosystem demo user
        Firebase.getAllUsers("Ecosystem", (users) => {
          const demoEcosystemUser = users.find((obj) => obj.isDemo);
          if (demoEcosystemUser) setDemoUser(demoEcosystemUser);
          setSelectedBrand({ value: 0, label: "Ecosystem" });
          setLoading(false);
          setBrands(brands);
        });
      });
    }
  }, [location]);

  const copyText = (url) => {
    document.getElementById("notify").click();
    navigator.clipboard.writeText(url);
  };
  const GroupItem = ({ toolName, asset }) => {
    return (
      <div className="group-input">
        <div className="group-label">
          {asset}
          {toolName}
        </div>
      </div>
    );
  };
  const GroupLink = ({ pageName }) => {
    if (!demoUser || !selectedBrand) return null;
    const { id } = demoUser;
    return (
      <div className="group-input">
        <div className={`hyperlink-div`}>
          <p
            className="right-text"
            onClick={() =>
              copyText(
                `https://ecosystem.life/${selectedBrand.label.replace(
                  /\s/g,
                  ""
                )}?page=${pageName}&uid=${id}`
              )
            }
          >
            https://ecosystem.life/{selectedBrand.label.replace(/\s/g, "")}
            ?page={pageName}&uid={id}
          </p>
        </div>
      </div>
    );
  };
  const handleChangeBrand = (brand) => {
    setSelectedBrand(brand);
    setLoading(true);
    Firebase.getAllUsers(brand.label, (users) => {
      const demoUser = users.find((obj) => obj.isDemo);
      setLoading(false);
      if (demoUser) setDemoUser(demoUser);
      else alert("We have encountered issue to get demo user from db");
    });
  };
  return (
    <div id="page-container">
      {loading && (
        <div className="loading_gif">
          <i className="fa fa-4x fa-sync fa-spin text-muted" />
        </div>
      )}
      <Header username={username} role={role} />
      <main id="main-container" className="platform-links-content">
        <div className="home-content">
          <React.Fragment>
            <div className="left-content">
              <div id="brand-selector" className="select-container mb-3">
                <Select
                  value={selectedBrand}
                  onChange={handleChangeBrand}
                  options={(_.sortBy(brands, ["name"]) || []).map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                />
              </div>
              {groups.map((group) => (
                <GroupItem {...group} />
              ))}
            </div>
            <div className="right-content">
              <h3>Link</h3>
              {groups.map((group) => (
                <GroupLink {...group} />
              ))}
            </div>
          </React.Fragment>
        </div>
      </main>
    </div>
  );
};

export default React.memo(PlatformLinks);



// WEBPACK FOOTER //
// ./src/screens/PlatformLinks/index.js